import { checkDuplicateContributorOrcid } from "./orcidUtils";

export function getValidationError({
  field,
  fieldPath,
  valuePath,
  value,
  readOnly,
  formatPatterns,
  depFormatPatterns,
  allFormValues,
}) {
  const { name, label, required } = field;

  // 1. Required validation
  if (required && (!value || String(value).trim() === "")) {
    return `${label || name} is required`;
  }

  // 2. Skip if readOnly or empty (after required check)
  if (readOnly || !value) return null;

  // 2.5. Duplicate Contributor ORCID check
  if (allFormValues) {
    const pathToUse = valuePath || fieldPath;
    const dupCheck = checkDuplicateContributorOrcid(allFormValues, pathToUse, value);
    if (dupCheck.isDuplicate) {
      const dupLabel = dupCheck.duplicateName
        ? `${dupCheck.duplicateName} (${dupCheck.duplicateOrcid})`
        : dupCheck.duplicateOrcid;
      return `Contributor already added: ${dupLabel}`;
    }
  }

  // 3. Field name from path
  const pathToExtract = fieldPath || valuePath || "";
  const fieldName = pathToExtract.split(".").pop() || name;

  // 4. Merge patterns
  const allPatterns = { ...formatPatterns, ...depFormatPatterns };
  const patternData = allPatterns[fieldName];
  if (!patternData) return null;

  // 5. Normalize pattern
  let regexPattern;
  if (typeof patternData === "string") {
    regexPattern = patternData;
  } else if (patternData?.source && patternData.type === "regex") {
    regexPattern = patternData.source;
  }
  if (!regexPattern) return null;

  // 6. Test regex
  try {
    const regex = new RegExp(regexPattern, "i");
    if (!regex.test(value)) {
      return `Invalid format for ${label || fieldName}`;
    }
  } catch (err) {
    console.error("Regex compilation failed:", regexPattern);
    return null;
  }
  return null;
}

export function getMaxLengthFromPattern(fieldName, formatPatterns, depFormatPatterns) {
  const allPatterns = { ...formatPatterns, ...depFormatPatterns };
  const patternData = allPatterns[fieldName];
  if (!patternData) return null;

  let regexPattern;
  if (typeof patternData === "string") {
    regexPattern = patternData;
  } else if (patternData?.source && patternData.type === "regex") {
    regexPattern = patternData.source;
  }
  if (!regexPattern) return null;

  const match = regexPattern.match(/\{(\d+)?,(\d+)?\}\$?$/);
  if (match && match[2]) {
    return parseInt(match[2], 10);
  }

  const exactMatch = regexPattern.match(/\{(\d+)\}\$?$/);
  if (exactMatch && exactMatch[1]) {
    return parseInt(exactMatch[1], 10);
  }

  return null;
}
